import { createRouter, createWebHashHistory } from 'vue-router'
import { checkAppUserAgent, jsbridge, setupWebViewJavascriptBridge } from "../utils";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


let flag = false
router.afterEach(async () => {
  if(checkAppUserAgent() && !flag) {


    let res = await jsbridge('getStatusHeight', '')
    console.log(res);
    document.body.style.paddingTop = (window.innerWidth * res)+'px'
    
    
    flag = true

}

  let loading = document.querySelector('#loading')
  if (loading.style.display !== 'none') {
    loading.style.display = 'none'
  }



})

export default router
